/**
 * Opens the detailed view of a lookbook.
 * 
 * @param {number} index - The index of the lookbook to open.
 */
function mmOpenLook(index) {
    document.querySelector('.mm-look-cart-filter-' + index).classList.add('mm-look-is-open');
    document.querySelector('html').classList.add('stop-scrolling');
    setTimeout(() => {
        showBgFilter();
    }, 300);
}

/**
 * Opens and refreshes the detailed view of a lookbook.
 * 
 * @param {number} index - The index of the lookbook to open and refresh.
 */
function mmOpenAndRefreshCart(index) {
    function handleResponse() {
        const newCartEl = document.createElement('DIV');
        newCartEl.innerHTML = this.responseText;
        const innerCart = mmCartSectionElement().querySelector('.mm-look-cart-filter-' + index);
        innerCart.innerHTML = newCartEl.querySelector('.mm-look-cart-filter-' + index).innerHTML;
        mmInitSplide(index);
        document.querySelector('.mm-look-cart-filter-' + index).classList.add('mm-look-is-open');
        document.querySelector('html').classList.add('stop-scrolling');
    }
    const request = new XMLHttpRequest();
    request.addEventListener('load', handleResponse);
    request.open('GET', '/?section_id=mm-lookbook', true);
    request.send();
}

/**
 * Closes the detailed view of a lookbook.
 * 
 * @param {number} index - The index of the lookbook to close.
 */
function mmCloseLook(index) {
    hideBgFilter();
    document.querySelector('.mm-look-cart-filter-' + index).classList.remove('mm-look-is-open');
    document.querySelector('html').classList.remove('stop-scrolling');
}

